import * as z from "zod/v4";

export const createAeoPromptTopic = {
  name: "createAeoPromptTopic" as const,
  input: z.object({
    name: z.string(),
    color: z.string().nullable().optional(),
  }),
  output: z.object({
    id: z.bigint(),
    name: z.string(),
    color: z.string().nullable(),
  }),
};
